import { parseISODate } from 'shared/utils/date';
import { format, isValid } from 'date-fns';
import { de, enGB, enUS, nl, sv, es, fr, ja } from 'date-fns/locale';
import { LocaleEnum } from 'schema/locale';
import { useLocale } from 'shared/hooks/useLocale';
import { useCallback } from 'react';

export enum DateFormat {
  Short = 'short',
  Long = 'long'
}

const locales: Record<LocaleEnum, Locale> = {
  [LocaleEnum.enUK]: enGB,
  [LocaleEnum.enUS]: enUS,
  [LocaleEnum.apacUS]: enUS,
  [LocaleEnum.enAU]: enUS,
  [LocaleEnum.enNZ]: enUS,
  [LocaleEnum.enEU]: enGB,
  [LocaleEnum.deEU]: de,
  [LocaleEnum.enDev]: enUS,
  [LocaleEnum.enQa]: enUS,
  [LocaleEnum.deQa]: de,
  [LocaleEnum.enAud]: enUS,
  [LocaleEnum.enNzd]: enUS,
  [LocaleEnum.enEud]: enGB,
  [LocaleEnum.enUkd]: enGB,
  [LocaleEnum.deEud]: de,
  [LocaleEnum.seEU]: sv,
  [LocaleEnum.nlEU]: nl,
  [LocaleEnum.esEU]: es,
  [LocaleEnum.frEU]: fr,
  [LocaleEnum.enJP]: ja,
  [LocaleEnum.jaJP]: ja
};

export function useDateFormatting(formatString: DateFormat = DateFormat.Long) {
  const language = useLocale();

  return useCallback(
    (date: Date | string | null) => {
      const newDate = typeof date === 'string' ? parseISODate(date) : date;

      if (newDate === null || !isValid(newDate)) {
        return '';
      }

      let fnsFormatString = formatString === DateFormat.Short ? 'PP' : 'PPP';

      if (formatString === DateFormat.Long) {
        fnsFormatString = language === LocaleEnum.enUS ? 'LLLL d, yyyy' : 'PPP';
      }

      return format(newDate, fnsFormatString, {
        locale: locales[language]
      });
    },
    [language, formatString]
  );
}
